import {useEffect, useState} from "react";

export function useFormatFile(file) {
    const [fileDataUrl, setFileDataUrl] = useState(null);
    useEffect(() => {
        let fileReader, isCancel = false;
        if (file !== null) {
            fileReader = new FileReader();
            fileReader.onload = (e) => {
                const { result } = e.target;
                if (result && !isCancel) {
                    setFileDataUrl(result);
                }
            };
            fileReader.readAsDataURL(file? file : null);
        }
        return () => {
            isCancel = true;
            if (fileReader && fileReader.readyState === 1) {
                fileReader.abort();
            }
        }
    }, [file]);
    return fileDataUrl;
}
